import dayjs from 'dayjs';
import { decodeJwt } from 'jose';
import { useCookies } from 'react-cookie';
import { AuthClient } from '@/api';
import { COOKIE_OPTIONS, COOKIES_KEYS } from '@/constants';
import { resolveRefreshTokenExpiry } from '@/utils/resolveRefreshTokenExpiry';
type Token = string | null;
export const useAccessToken = () => {
  const [cookies, setCookies, removeCookies] = useCookies([COOKIES_KEYS.ACCESS_TOKEN, COOKIES_KEYS.REFRESH_TOKEN]);
  const accessToken: Token = cookies.accessToken || null;
  const refreshToken: Token = cookies.refreshToken || null;
  const setAccessToken = (token: Token) => {
    if (!token) {
      AuthClient.setConfig({
        auth: undefined
      });
      removeCookies(COOKIES_KEYS.ACCESS_TOKEN, COOKIE_OPTIONS);
      return;
    }
    try {
      const decoded = decodeJwt(token);
      const exp = dayjs.unix(decoded.exp ?? 0);
      if (!decoded.exp || exp.isBefore(dayjs())) {
        AuthClient.setConfig({
          auth: undefined
        });
        removeCookies(COOKIES_KEYS.ACCESS_TOKEN, COOKIE_OPTIONS);
        return;
      }
      AuthClient.setConfig({
        auth: token
      });
      setCookies(COOKIES_KEYS.ACCESS_TOKEN, token, {
        ...COOKIE_OPTIONS,
        expires: exp.toDate()
      });
    } catch {
      AuthClient.setConfig({
        auth: undefined
      });
      removeCookies(COOKIES_KEYS.ACCESS_TOKEN, COOKIE_OPTIONS);
    }
  };
  const setRefreshToken = (token_0: Token) => {
    if (!token_0) {
      removeCookies(COOKIES_KEYS.REFRESH_TOKEN, COOKIE_OPTIONS);
      return;
    }
    const expires = resolveRefreshTokenExpiry(token_0);
    if (dayjs(expires).isBefore(dayjs())) {
      removeCookies(COOKIES_KEYS.REFRESH_TOKEN, COOKIE_OPTIONS);
      return;
    }
    setCookies(COOKIES_KEYS.REFRESH_TOKEN, token_0, {
      ...COOKIE_OPTIONS,
      expires
    });
  };
  return {
    accessToken,
    refreshToken,
    setAccessToken,
    setRefreshToken
  };
};